import "./NextPreviousPhaseButtons.css";

import { useContext } from "react";

import { ArrowheadLeftLightIcon } from "../../../../../../../assets";
import { Button } from "../../../../../../../widget";
import { WorkflowTemplateContext } from "../../WorkflowTemplateContext";

export const NextPreviousPhaseButtons = (): JSX.Element => {
  const { projectPhase, handlePhaseChange, workflowTemplatePhases } = useContext(WorkflowTemplateContext);
  const currentPhaseIndex = workflowTemplatePhases.findIndex((item) => item.phase === projectPhase);
  const previousPhase = currentPhaseIndex > 0 ? workflowTemplatePhases[currentPhaseIndex - 1]?.phase : undefined;
  const nextPhase =
    currentPhaseIndex >= 0 && currentPhaseIndex < workflowTemplatePhases.length - 1
      ? workflowTemplatePhases[currentPhaseIndex + 1]?.phase
      : undefined;

  return (
    <div className="NextPreviousPhaseButtonsContainer">
      {previousPhase && (
        <Button
          text="Previous"
          variant="tertiary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadLeftBlueIcon" />}
          iconPosition="left"
          onClick={() => handlePhaseChange(previousPhase)}
        />
      )}
      {nextPhase && (
        <Button
          text="Next"
          variant="primary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadRightLightIcon" />}
          onClick={() => handlePhaseChange(nextPhase)}
        />
      )}
    </div>
  );
};
